<template>
  <div class="overlay" @click="handleOverlayClick">
    <div class="modal-content" @click.stop>
      <img
          src="https://imagedelivery.net/rz4kIC2FHjrPe9mGQi46Fw/300bdd89-bd4a-45fd-5d58-f0ecb7896f00/fullpage"
          @click="handleImageClick"
          class="clickable-image"
          alt="Download App"
      />
      <div class="x-button-area" @click="closeModal">
      </div>
    </div>
  </div>
</template>

<script>
import {logEvent} from "@/tarot_box/helper/native_api";

export default {
  name: 'AppDownloadModal',
  emits: ['close'],
  data() {
    return {
      escListener: null
    }
  },
  methods: {
    detectDevice() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // iOS 감지
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'ios';
      }

      // iPadOS 13+ 감지 (데스크탑 모드)
      if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
        return 'ios';
      }

      // Android 감지
      if (/android/i.test(userAgent)) {
        return 'android';
      }

      // Windows Phone 감지
      if (/windows phone/i.test(userAgent)) {
        return 'windows';
      }

      // 기타 모바일 기기 감지
      if (/Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(userAgent)) {
        return 'mobile-other';
      }

      // PC 환경
      return 'desktop';
    },

    handleImageClick() {
      const device = this.detectDevice();
      let url = '';

      // 디바이스별 URL 설정
      switch(device) {
        case 'ios':
          url = 'https://apps.apple.com/kr/app/id6446103793';
          break;
        case 'android':
          url = 'https://play.google.com/store/apps/details?id=com.onez.mytarotgpt&hl=ko';
          break;
        case 'desktop':
          // 데스크탑에서는 두 링크를 모두 보여주거나, 선택하게 할 수 있음
          this.showDesktopOptions();
          return;
        default:
          // 기타 환경에서는 Android 스토어로 이동
          url = 'https://play.google.com/store/apps/details?id=com.onez.mytarotgpt&hl=ko';
      }

      logEvent('result_appdown_gogo_click', {
        device: device
      });

      // 새 창에서 열기
      window.open(url, '_blank', 'noopener,noreferrer');
    },

    showDesktopOptions() {
      // 데스크탑에서 선택 옵션 제공
      const confirmed = confirm(
          '앱을 다운로드할 스토어를 선택해주세요.\n\n' +
          '확인: App Store (iOS)\n' +
          '취소: Google Play Store (Android)'
      );

      const url = confirmed
          ? 'https://apps.apple.com/kr/app/id6446103793'
          : 'https://play.google.com/store/apps/details?id=com.onez.mytarotgpt&hl=ko';

      window.open(url, '_blank', 'noopener,noreferrer');

    },

    closeModal() {
      this.$emit('close');
    },

    handleOverlayClick() {
      this.closeModal();
    },

    handleEscKey(e) {
      if (e.key === 'Escape') {
        this.closeModal();
      }
    }
  },
  mounted() {
    this.escListener = this.handleEscKey.bind(this);
    document.addEventListener('keydown', this.escListener);
  },
  beforeUnmount() {
    if (this.escListener) {
      document.removeEventListener('keydown', this.escListener);
    }
  }
}
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(115, 120, 135, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
  box-sizing: border-box;
}

.modal-content {
  position: relative;
  width: calc(100% - 40px);
  max-width: 400px;
  height: auto;
  background: #0A507D;
  border-radius: 24px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  animation: fadeInScale 0.3s ease;
}

.modal-content img {
  width: 100%;
  height: auto;
  border-radius: 24px;
  display: block;
}

.clickable-image {
  cursor: pointer;
  transition: transform 0.2s ease;
}

.clickable-image:hover {
  transform: scale(0.98);
}

.clickable-image:active {
  transform: scale(0.96);
}

.x-button-area {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
}

@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0px);
  }
}
</style>